import React, { useEffect, useState } from "react";

import * as THREE from "three";
import { useThree } from "react-three-fiber";

import { Hype, Chill, Pop, Chillup } from "../data/songs";

import {
  getDirectionalLight,
  getPointLight,
  getSpotLight,
  NeonLight,
} from "./Lights";

import { noise } from "./Math/Noise";
import Effects from "./Effects";
import useWindowSize from "../hooks/useWindowSize";

let sphere_geometry = new THREE.SphereGeometry(2, 100, 100);
let material = new THREE.MeshPhongMaterial({
  color: "#ebedf5",
  emissive: "#101041",
});

// emerald 0.35, 1, 0.5
let sphere = new THREE.Mesh(sphere_geometry, material);
// sphere.material.flatShading = false;
const Visualizer = ({ onFactorUpdate, mood, theme }) => {
  const {
    gl, // WebGL renderer
    scene, // Default scene
    camera, // Default camera
  } = useThree();

  const size = useWindowSize();

  const [factor, setFactor] = useState(0.03);

  function animateBlob() {
    // aggressiveness
    let time = performance.now() * 0.003;

    let k = 3.15 + factor;
    for (let i = 0; i < sphere.geometry.vertices.length; i++) {
      let p = sphere.geometry.vertices[i];
      p.normalize().multiplyScalar(
        (size.width > 520 ? 0.64 : size.width > 400 ? 0.59 : 0.5) +
          (factor > 1.8
            ? factor > 2
              ? factor > 2.2
                ? factor / 0.5
                : factor / 0.8
              : factor / 1
            : factor / 1.5) *
            noise.perlin2(p.x * k + time, p.y * k)
      );
    }
    sphere.geometry.computeVertexNormals(true);
    sphere.geometry.normalsNeedUpdate = true;
    sphere.geometry.verticesNeedUpdate = true;
  }

  useEffect(() => {
    onFactorUpdate([factor, setFactor]);
    animateBlob();
  }, [onFactorUpdate, factor]);

  useEffect(() => {
    theme
      ? (gl.outputEncoding = THREE.sRGBEncoding)
      : (gl.outputEncoding = THREE.LinearEncoding);
  }, [theme]);

  useEffect(() => {
    // default bg canvas color
    gl.setClearColor("rgb(2,2,10)");

    gl.setPixelRatio(window.devicePixelRatio);

    camera.position.set(0, 0, 2);

    scene.fog = new THREE.FogExp2("rgb(3,3,8)", 0.22);

    scene.add(sphere);

    // lighting
    // var keyLight = getPointLight("#9b94e0", 0.1);
    // keyLight.position.set(-2, 2, 4);

    // var keyLightFolder = gui.addFolder("Key Light");
    // keyLightFolder.add(keyLight, "intensity", 0, 10);
    // keyLightFolder.add(keyLight.position, "x", -20, 20);
    // keyLightFolder.add(keyLight.position, "y", -20, 20);
    // keyLightFolder.add(keyLight.position, "z", -20, 20);

    // scene.add(keyLight);

    // var rimLightFolder = gui.addFolder("Rim Light");
    // rimLightFolder.add(rimLight, "intensity", 0, 10);
    // rimLightFolder.add(rimLight.position, "x", -20, 20);
    // rimLightFolder.add(rimLight.position, "y", -20, 20);
    // rimLightFolder.add(rimLight.position, "z", -20, 20);

    // var fillLight = getDirectionalLight("#fff", 0.01);
    // fillLight.castShadow = true;
    // fillLight.position.set(1.5, -2, 0.9);

    // var redNeonLightFolder = gui.addFolder("Fill Light");
    // redNeonLightFolder.add(fillLight, "intensity", 0, 10);
    // redNeonLightFolder.add(fillLight.position, "x", -20, 20);
    // redNeonLightFolder.add(fillLight.position, "y", -20, 20);
    // redNeonLightFolder.add(fillLight.position, "z", -20, 20);

    // scene.add(fillLight);
  }, []);

  return (
    <>
      <Effects
        factor={
          mood === Hype || mood === Chillup
            ? factor
            : mood === Pop
            ? factor - 0.1
            : 0
        }
      />
      <pointLight color="#9b94e0" intensity={0.01} position={[-2, 2, 4]} />
      <directionalLight
        color="#fff"
        intensity={0.01}
        castShadow={true}
        position={[1.5, -2, 0.9]}
      />
      <NeonLight
        color={`${mood === Hype || mood === Pop ? "#ff2652" : "#6f8ee2"}`}
        size={0.2}
        intensity={mood === Hype || mood === Pop ? 4 : 1.5}
        position={[-2.4 + factor*2, -0.2, -0.9]}
      />
      <NeonLight
        color="#3165d6"
        size={1}
        intensity={2}
        position={[-0.3, -1, 0.04]}
      />
      <NeonLight
        color="#3165d6"
        size={1}
        intensity={2}
        position={[-0.3, 1, 0.02]}
      />
      <NeonLight
        color="#655acc"
        size={2}
        intensity={0.5}
        position={[0.8, -0.8, 0.1]}
      />
      <NeonLight
        color="#fff"
        size={2}
        intensity={theme ? 1 - factor*3 : 2.2 - factor*3}
        position={[1.25, 0.5, -0.3]}
      />
      <NeonLight
        color="#3969d6"
        size={5}
        intensity={12.5}
        position={[0, 0.1, -0.6]}
      />
      <pointLight color="#7f5dba" position={[3, 2, 4]} intensity={0.25} />
    </>
  );
};

export default Visualizer;
